{
  "version": 1,
  "asset_id": "e3e3eccc-911c-4e1d-8af5-e727afdb84ff",
  "project_id": "f9ca952a-2109-492f-a7b0-0345b2dfa2e1",
  "url": "/__l5e/assets-v1/e3e3eccc-911c-4e1d-8af5-e727afdb84ff/sa-lexpractiq-logo.png",
  "r2_key": "a/v1/f9ca952a-2109-492f-a7b0-0345b2dfa2e1/e3e3eccc-911c-4e1d-8af5-e727afdb84ff/sa-lexpractiq-logo.png",
  "original_filename": "sa-lexpractiq-logo.png",
  "size": 1664140,
  "content_type": "image/png",
  "created_at": "2026-07-27T08:24:30Z"
}
